import React from "react"
import PropTypes from "prop-types"
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material"
import { grey } from "@mui/material/colors"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { DataGridPro } from "@mui/x-data-grid-pro"

const AccordionWithDataGridPro = ({ title, rows, dataGridProps }) => (
  <Accordion>
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      sx={{ backgroundColor: grey[300] }}
    >
      <Typography>{title}</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Box sx={{ width: "100%", height: 300 }}>
        <DataGridPro rows={rows} {...dataGridProps} />
      </Box>
    </AccordionDetails>
  </Accordion>
)

AccordionWithDataGridPro.propTypes = {
  title: PropTypes.string.isRequired,
  rows: PropTypes.array.isRequired,
  dataGridProps: PropTypes.object,
}

export default AccordionWithDataGridPro
